import { useCurrentWallet } from './walletCompat';
import { useBalances } from '../context/BalanceContext';
import { normalizeCoinType } from '../utils/coinDisplayUtils';
// Wallets that cannot spend funds held in the Sui address-level accumulator.
// Add new wallet name substrings here as more are identified.
const WALLETS_WITHOUT_ADDRESS_BALANCE_SUPPORT = ['phantom', 'onekey', 'okx'];
/**
 * Returns a checker function that returns true when the connected wallet has
 * any address-balance funds for the given coin types.
 */
export function useAddressBalanceGuard() {
    const { currentWallet } = useCurrentWallet();
    const { addressBalancesMap } = useBalances();
    const isUnsupportedWallet = typeof (currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.name) === 'string' &&
        WALLETS_WITHOUT_ADDRESS_BALANCE_SUPPORT.some((w) => currentWallet.name.toLowerCase().includes(w));
    return (checks) => {
        if (!isUnsupportedWallet || !addressBalancesMap || addressBalancesMap.size === 0)
            return false;
        return checks.some(({ coinType }) => {
            if (!coinType)
                return false;
            return addressBalancesMap.has(normalizeCoinType(coinType));
        });
    };
}
